import React, { useCallback, useMemo } from 'react'
import { useTrip, useTrips } from 'tripPlanner/hooks/api/trip'
import { EmptyArray } from 'lib/array/arrayUtils'
import { BasicTrip } from 'tripPlanner/types/common'
import TripHomePage from './TripHomePage'
import { getCanShowTripModule } from './utils'
import { useUserSettings } from 'tripPlanner/hooks/api/userSettings'
import { getTripURL } from 'tripPlanner/utils'
import { useHomePageTripData } from '../../hooks/useHomePageTripData'
import useNavigateTo from 'hooks/useNavigateTo'
import { getTripViewedTimes, sortUpcomingTripsByRecentlyViewed } from 'tripPlanner/utils/recentTrips'
import useOrders from 'hooks/Order/useOrders'

interface Props {
  onDismiss: () => void
}

function TripHomepageContainer({ onDismiss }: Props) {
  const { data: trips = EmptyArray as Array<BasicTrip> } = useTrips()
  const { data: userSettings } = useUserSettings()
  const canShowTripModule = getCanShowTripModule(userSettings)
  const navigateTo = useNavigateTo()
  const [orders] = useOrders()
  let tripWithDestinationsGeo: BasicTrip | undefined
  const tripToShow = useMemo(() => {
    if (trips.length === 0) return undefined

    const sortedTrips = sortUpcomingTripsByRecentlyViewed(trips, getTripViewedTimes())
    return sortedTrips[0]
  }, [trips])
  tripWithDestinationsGeo = tripToShow
  const tripData = useHomePageTripData({ orders, selectedTrip: tripToShow })

  const { data: trip, isError } = useTrip({
    tripId: tripToShow?.id,
    withPlaceholder: false,
    enabled: canShowTripModule && !!tripToShow,
  })

  const onSelectTrip = useCallback((tripId: string) => {
    navigateTo(getTripURL(tripId))
  }, [navigateTo])

  const shouldShowTripModule = canShowTripModule && !isError && (
    (tripToShow?.destinationsGeo && tripToShow.destinationsGeo.length > 0) ||
    (tripData.lat && tripData.lng && tripData.location)
  )
  if (!tripToShow?.destinationsGeo) {
    tripWithDestinationsGeo = undefined
  }
  return (
    <>
      {shouldShowTripModule && <TripHomePage
        basicTrip={tripWithDestinationsGeo}
        trip={trip}
        tripData={tripData}
        onSelectTrip={onSelectTrip}
        trips={trips}
        onDismiss={onDismiss}
      />}
    </>
  )
}

export default TripHomepageContainer
